// removed by extract-text-webpack-plugin
module.exports = {"picker":"_1hB9ZceZw0lwGHDmzLMWZ1"};


//////////////////
// WEBPACK FOOTER
// ./app/components/OrPicker/style.scss
// module id = 958
// module chunks = 0